const LIBRARY_COMPARE_FROM = {
  'draft-job-profiles': {
    backTo: { name: 'draft-job-profiles' },
    label: 'Draft Job Profiles',
  },
  'hris-job-profiles': {
    backTo: { name: 'hris-job-profiles' },
    label: 'Workday Job Profiles',
  },
  'job-architecture': {
    backTo: { name: 'job-architecture', query: { view: 'list' } },
    label: 'Job Architecture',
  },
};

const EDITOR_COMPARE_FROM = {
  'job-profile-view': {
    label: 'Draft Job Profile',
  },
  'job-profile-hris-view': {
    label: 'Workday Job Profile',
  },
};

export const isEditorCompareFrom = (from) => Boolean(EDITOR_COMPARE_FROM[from]);

// Pick the compare page back link. If we came from an editor with an id, go back there.
export const resolveCompareBreadcrumb = ({
  from,
  fromId,
  hrisUlids = [],
  draftUlids = [],
} = {}) => {
  if (isEditorCompareFrom(from) && fromId) {
    return {
      from,
      label: EDITOR_COMPARE_FROM[from].label,
      backTo: {
        name: from,
        params: { id: fromId },
      },
    };
  }

  const noSelection = hrisUlids.length === 0 && draftUlids.length === 0;

  if (noSelection) {
    const fallbackFrom = LIBRARY_COMPARE_FROM[from] ? from : 'job-architecture';

    return {
      from: fallbackFrom,
      ...LIBRARY_COMPARE_FROM[fallbackFrom],
    };
  }

  const isDraftOnly = hrisUlids.length === 0 && draftUlids.length > 0;
  const isHrisOnlyFromLibrary = hrisUlids.length > 0
    && draftUlids.length === 0
    && from === 'hris-job-profiles';

  let resolvedFrom = 'job-architecture';

  if (isDraftOnly) resolvedFrom = 'draft-job-profiles';
  else if (isHrisOnlyFromLibrary) resolvedFrom = 'hris-job-profiles';

  return {
    from: resolvedFrom,
    ...LIBRARY_COMPARE_FROM[resolvedFrom],
  };
};
